import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";

import FetchModule from "../../Share/Network/FetchModule";
import moment from "moment";
import WaittingModal from "./WaittingModal";
import AlertModal from "./AlertModal";
// import ClassSelectModal from "./ClassSelectModal";
import ClassSelectView from "./ClassSelectView";

import EntranceMP3 from '../../../audio/Entrance.mp3';
import ExpireErrorMP3 from '../../../audio/ExpireError.mp3';
// import DuplicateMemberSelectModal from "./DuplicateMemberSelectModal";
import DuplicateMemberSelectView from "./DuplicateMemberSelectView";
import HoldingStateModal from "./HoldingStateModal";
import WeekAttendanceStatusView from "./WeekAttendanceStatusView";

import LeftArrow from '../../../image/LeftArrow.svg';
import FullScreenOn from '../../../image/FullScreenOn.svg';
import FullScreenOff from '../../../image/FullScreenOff.svg';
import CloseEyesRingRing from '../../../image/CloseEyesRingRing.png';
import OpenEyesRingRing from '../../../image/OpenEyesRingRing.png';
import NotFoundedRingRing from '../../../image/NotFoundRingRing.png';
import RingRingHands from '../../../image/RingRingHands.png';
import RingRingHand from '../../../image/RingRingHand.png';
import MondayRingRing from '../../../image/MondayRingRing.png';
import TuesdayRingRing from '../../../image/TuesdayRingRing.png';
import WedsdayRingRing from '../../../image/WednesdayRingRing.png';
import ThursdayRingRing from '../../../image/ThursdayRingRing.png';
import FridayRingRing from '../../../image/FridayRingRing.png';
import NotFoundView from "./NotFoundView";
import KeypadInputView from "./KeypadInputView";
import TicketSelectView from "./TicketSelectView";
import PoweredByLinkoImage from "./PoweredByLinkoImage";

export default function KeypadView() {

  const history = useHistory();

  const [isProcessing, setIsProcessing] = useState(false);
  const [isViewAlert, setIsViewAlert] = useState(false);
  const [firstAlertText, setFirstAlertText] = useState('출석이 완료되었습니다');
  const [secondAlertText, setSecondAlertText] = useState('5초뒤 메인화면으로 이동합니다');
  const [processingText, setProcessingText] = useState('');
  const [middlePhone, setMiddlePhone] = useState('');
  const [lastPhone, setLastPhone] = useState('');
  const [memberInfo, setMemberInfo] = useState({
    profile: '',
  });
  const [usages, setUsages] = useState([]);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [isShowFullscreenButton, setIsShowFullscreenButton] = useState(false);

  const [scheduleData, setScheduleData] = useState([]);
  const [breakTimeData, setBreakTimeData] = useState([]);
  const [useScheduleData, setUseScheduleData] = useState([]);
  const [reserveData, setReserveData] = useState([]);
  const [today, setToday] = useState(moment());
  const [isInputPhone, setIsInputPhone] = useState(false);

  const [clickTicket, setClickTicket] = useState({

  });

  const [duplicateMembers, setDuplicateMembers] = useState([]);

  const [holdingUsage, setHoldingUsage] = useState(undefined);

  const [isSelectClass, setIsSelectBox] = useState(false);
  const [isDuplicateView, setIsDuplicateView] = useState(false);
  const [isInfoView, setIsInfoView] = useState(false);
  const [isViewHoldingModal, setIsViewHoldingModal] = useState(false);

  const [isViewCompleteAttendance, setIsViewCompleteAttendance] = useState(false);
  const [dayOfTheWeek, setDayOfWeek] = useState('Mon');
  const [attendanceData, setAttendanceData] = useState({
    storeName: '',
    totalAttendance: 0,
    mon: false,
    tue: false,
    wed: false,
    thu: false,
    fri: false,
    sat: false,
    sun: false
  });

  const KeypadRef = useRef();
  const InfoRef = useRef();
  const MiddleRef = useRef();
  const LastRef = useRef();


  // 전체화면 상태 변경 이벤트 리스너 등록 //
  useEffect(() => {
    function onFullscreenChange() {
      const isFull = !!(document.fullscreenElement || document.webkitFullscreenElement);
      // viewport가 완전히 안정화된 후에 상태 업데이트 (주소창 유무에 따른 비율 불일치 방지)
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setIsFullscreen(isFull);
        });
      });
    }

    document.addEventListener('fullscreenchange', onFullscreenChange);
    document.addEventListener('webkitfullscreenchange', onFullscreenChange);

    return () => {
      document.removeEventListener('fullscreenchange', onFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', onFullscreenChange);
    };
  }, []);

  // 화면 진입 시 FullscreenButton 5초 표시 //
  useEffect(() => {
    setIsShowFullscreenButton(true);
    const timer = setTimeout(() => setIsShowFullscreenButton(false), 5000);
    return () => clearTimeout(timer);
  }, []);

  // 전체화면 시 iPad WebKit 스크롤 방지 //
  useEffect(() => {
    if (isFullscreen) {
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = '0';
      document.body.style.left = '0';
      document.body.style.width = '100%';
      document.body.style.height = '100%';
      document.body.style.backgroundColor = '#0A0A0A';
      document.documentElement.style.overflow = 'hidden';
      document.documentElement.style.backgroundColor = '#0A0A0A';
    }
    else {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.width = '';
      document.body.style.height = '';
      document.body.style.backgroundColor = '';
      document.documentElement.style.overflow = '';
      document.documentElement.style.backgroundColor = '';
    }
    return () => {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.width = '';
      document.body.style.height = '';
      document.body.style.backgroundColor = '';
      document.documentElement.style.overflow = '';
      document.documentElement.style.backgroundColor = '';
    };
  }, [isFullscreen]);

  // Schedule Data API 호출 //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postData('schedule/', 'POST');

        if (responseData.status === 200) setScheduleData(responseData.data);
      }
    )();
  }, [history])


  // Schedule Data를 사용 가능한 Data로 가공
  useLayoutEffect(() => {
    let tmp = scheduleData.slice();
    let newScheduleData = [];

    for (let i = 0; i < tmp.length; i++) {

      let endPoint = moment(tmp[i].classDate.split('T')[0]);

      while (endPoint.isBefore(moment(tmp[i].endDate))) {
        if (endPoint.diff(today, 'days') >= 30) break;

        if (tmp[i].repeatWeek.includes(getWeekNumber(endPoint.format('YYYY-MM-DD')).toString()) || tmp[i].repeatWeek.includes('0')) {
          if (tmp[i].applyWeek.includes(endPoint.format('ddd')) || tmp[i].applyWeek === 'All') {
            let newData = {
              classId: tmp[i].classId,
              classDate: endPoint.format('YYYY.MM.DD'),
              className: tmp[i].className,
              classTime: tmp[i].classTime,
              color: tmp[i].color,
              endDate: tmp[i].endDate,
              lessonId: tmp[i].lessonId,
              scheduleId: tmp[i].scheduleId,
              teacherName: tmp[i].teacherName,
              profile: tmp[i].profile,
              applyWeek: tmp[i].applyWeek,
              maxBookedPeople: tmp[i].maxBookedPeople,
              deduction: tmp[i].deduction
            }
            newScheduleData.push(newData);
          }
          // endPoint = endPoint.clone().add(7 * tmp[i].term, 'day');
        }
        endPoint = endPoint.clone().add(1, 'day');
      }
    }

    newScheduleData.sort(function (a, b) {
      return a.classDate < b.classDate ? -1 : a.classDate > b.classDate ? 1 : 0;
    })

    let newData = [];

    for (let i = 0; i < newScheduleData.length; i++) {

      if (newScheduleData[i].classDate === today.clone().format('YYYY.MM.DD')) {
        newData.push(newScheduleData[i]);
      }
    }

    // breaktime 데이터 가공
    for (let z = 0; z < breakTimeData.length; z++) {
      if (moment(breakTimeData[z].classDate).isBefore(moment(today.clone().format('YYYY-MM-DDT') + breakTimeData[z].startTime)) && moment(breakTimeData[z].endDate).isAfter(today.clone())) {
        if (breakTimeData[z].repeatWeek.includes(getWeekNumber(today.clone().format('YYYY-MM-DD'))) || breakTimeData[z].repeatWeek === '0') {
          if (breakTimeData[z].applyWeek.includes(today.clone().format('ddd')) || breakTimeData[z].applyWeek === 'All') {

            let breakData = {
              classId: -1,
              lessonId: -1,
              classDate: today.clone().format('YYYY.MM.DD'),
              color: '#ECECEC',
              classTime: breakTimeData[z].startTime + '-' + breakTimeData[z].endTime,
              className: '브레이크 타임',
              applyWeek: breakTimeData[z].applyWeek
            }

            newData.push(breakData);
          }
        }
      }
    }

    newData.sort(function (a, b) {
      return a.classTime < b.classTime ? -1 : a.classTime > b.classTime ? 1 : 0;
    })

    // TimeDivisionLine에서 사용할 데이터 가공
    for (let i = 0; i < newData.length; i++) {
      tmp = newData[i].classTime.split('-');
      let splitTmp = tmp[0].split(':');
      let Time = '';

      if (parseInt(splitTmp[0]) > 12) {
        newData[i].startTime = (parseInt(splitTmp[0]) - 12) + ':' + splitTmp[1] + ' PM';
        Time = (parseInt(splitTmp[0]) - 12) + ' PM';
      }
      else {
        newData[i].startTime = splitTmp[0] + ':' + splitTmp[1] + ' AM';
        Time = parseInt(splitTmp[0]) + ' AM';
      }

      tmp = newData[i].classTime.split('-');
      splitTmp = tmp[1].split(':');

      if (parseInt(splitTmp[0]) > 12) {
        newData[i].endTime = (parseInt(splitTmp[0]) - 12) + ':' + splitTmp[1] + ' PM';
      }

      else {
        newData[i].endTime = splitTmp[0] + ':' + splitTmp[1] + ' AM';
      }

      if (i !== 0 && newData[i - 1].startTime.split(':')[0] === newData[i].startTime.split(':')[0]) {
        newData[i] = Object.assign(newData[i], { isNeedNewDivide: false })
        newData[i] = Object.assign(newData[i], { viewTime: Time })
      }
      else {
        newData[i] = Object.assign(newData[i], { isNeedNewDivide: true })
        newData[i] = Object.assign(newData[i], { viewTime: Time })
      }
    }

    let newReserve = [];

    for (let h = 0; h < newData.length; h++) {
      newReserve.push(new Array());
    }

    let newTotalData = [];
    let newDataList = [];

    for (let i = 0; i < newData.length; i++) {
      // 중복검사 //
      let isExist = false;

      for (let j = 0; j < newTotalData.length; j++) {
        let isInnerExist = false;

        for (let z = 0; z < newTotalData[j].length; z++) {
          if (newTotalData[j][z].classDate === newData[i].classDate
            && newTotalData[j][z].classTime === newData[i].classTime
            && newTotalData[j][z].className === newData[i].className) {
            isExist = true;
            isInnerExist = true;
            break;
          }
        }

        if (isInnerExist) break;
      }

      if (!isExist) {
        newDataList.push(newData[i]);
      }
    }

    if (newDataList.length !== 0) newTotalData.push(newDataList);

    setReserveData(newReserve);
    setUseScheduleData(newData);
  }, [scheduleData, breakTimeData, today])

  // 몇주차인지 계산하기 //
  function getWeekNumber(date) {
    const standard = new Date(date);

    const currentDate = standard.getDate();
    const startOfMonth = new Date(standard.setDate(1));
    const weekDay = startOfMonth.getDay();

    return parseInt(((weekDay - 1) + currentDate) / 7) + 1;
  }


  // 숫자 클릭시 //
  function onClickNumber(number) {
    // 링링이 눈감기기 //
    if (!isInputPhone) setIsInputPhone(true);

    if (lastPhone.length < 4) setLastPhone(lastPhone + number);
  }

  // 수정 클릭시 //
  function onClickRemove() {
    if (lastPhone.length === 1 && isInputPhone) setIsInputPhone(false);
    if (lastPhone.length > 0) setLastPhone(lastPhone.slice(0, lastPhone.length - 1));
  }

  // 확인 클릭시 //
  function onClickFindInfo() {
    setToday(moment());

    const audio = new Audio();

    if (lastPhone.length !== 4) {
      setLastPhone('');

      setFirstAlertText('올바른 전화번호를 입력해주세요');
      setSecondAlertText('');

      setIsViewAlert(true);
      setIsProcessing(false);
      setIsInputPhone(false);

      setLastPhone('');

      audio.src = ExpireErrorMP3;
      audio.play();

      setTimeout(() => {
        setIsViewAlert(false);
      }, 5000)

      return;
    }

    setProcessingText('회원권을 확인중 입니다');
    setIsProcessing(true);
    setIsInputPhone(false);

    let requestData = {
      phone: lastPhone
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('reserve/keypad', 'POST', requestData);

        if (responseData.status === 200) {
          setMemberInfo(responseData.data);

          let usages = responseData.data.usages.slice();

          for (let i = 0; i < usages.length; i++) {
            let ids = usages[i].availableLessonIds.split(',');

            let newIds = [];

            for (let j = 0; j < ids.length; j++) {
              newIds.push(parseInt(ids[j]));
            }

            usages[i].lessonIds = newIds;
          }

          let finalUsage = [];

          for (let i = 0; i < usages.length; i++) {
            if (usages[i].count === undefined || usages[i].totalMax > usages[i].count || usages[i].totalMax === -1) {
              finalUsage.push(usages[i]);
            }
          }
          // scaleRepsFemaleRankData.sort((a, b) => b.completeRep - a.completeRep || a.tieBreak - b.tieBreak);
          // 회원권 시작날짜 순으로 오름차순 정렬 //
          finalUsage.sort((a, b) => new Date(a.startDate) - new Date(b.startDate));

          setUsages(finalUsage);

          if (usages.length === 1) {

            // 1개 소유하고 있는 사람의 회원권이 홀딩중일 경우 //
            if (usages[0].isHolding) {
              setIsViewHoldingModal(true);
              setHoldingUsage(usages[0]);
              setIsProcessing(false);
            }
            // 홀딩중이 아닐경우 //
            else {
              let checkRequestData = {
                usageId: usages[0].usageId
              };

              (
                async () => {
                  const checkResponseData = await fetchModule.postDataVersion2('reserve/attendance/check', 'POST', checkRequestData);

                  if (checkResponseData.status === 200) {
                    // setFirstAlertText('출석이 완료되었습니다');
                    // setSecondAlertText('3초뒤 메인화면으로 이동합니다');

                    audio.src = EntranceMP3;
                    audio.play();

                    setAttendanceData(checkResponseData.data);
                    setDayOfWeek(moment().format('ddd'));
                    setIsViewCompleteAttendance(true);
                    setIsProcessing(false);

                    // setIsViewAlert(true);
                    // setIsProcessing(false);

                    setTimeout(() => {
                      resetAll();
                    }, 5000)
                  }
                  else {
                    setIsProcessing(false);

                    setClickTicket(usages[0]);
                    setIsSelectBox(true);
                  }
                }
              )();
            }
          }
          else {

            setIsProcessing(false);
            setIsInfoView(true);

            if (InfoRef.current) {
              InfoRef.current.style.zIndex = 1;
              InfoRef.current.style.opacity = 1;
            }

            if (KeypadRef.current) {
              KeypadRef.current.style.zIndex = 0;
              KeypadRef.current.style.opacity = 0;
            }
          }
        }
        // 유효회원권이 존재하지 않는 회원의 경우 //
        else if (responseData.status === 201) {
          // alert('사용가능한 회원권이 존재하지 않습니다.\n회원권을 구매해주세요');
          setFirstAlertText('사용가능한 회원권이 없습니다');
          setSecondAlertText('회원권 구매 후 이용해주세요');

          setIsViewAlert(true);
          setIsViewCompleteAttendance(false);
          setIsProcessing(false);

          setMiddlePhone('');
          setLastPhone('');

          audio.src = ExpireErrorMP3;
          audio.play();

          setTimeout(() => {
            setIsViewAlert(false);
          }, 5000)
          return;
        }
        else if (responseData.status === 202) {
          setFirstAlertText('금일 사용량을 초과하였습니다');
          setSecondAlertText('5초뒤 메인화면으로 이동합니다');

          setIsViewAlert(true);
          setIsViewCompleteAttendance(false);
          setIsProcessing(false);

          setMiddlePhone('');
          setLastPhone('');

          audio.src = ExpireErrorMP3;
          audio.play();

          setTimeout(() => {
            setIsViewAlert(false);
          }, 5000)
          return;
        }
        // 중복된 번호가 존재할 경우 //
        else if (responseData.status === 203) {
          setDuplicateMembers(responseData.data);
          setIsDuplicateView(true);
          setIsProcessing(false);
        }
        // 유효회원권이 존재하지 않는 회원의 경우 //
        else if (responseData.status === 204) {
          // alert('사용가능한 회원권이 존재하지 않습니다.\n회원권을 구매해주세요');
          setFirstAlertText('등록정보가 존재하지 않습니다');
          setSecondAlertText('회원 등록 후 이용해주세요');

          setIsViewAlert(true);
          setIsViewCompleteAttendance(false);
          setIsProcessing(false);

          setMiddlePhone('');
          setLastPhone('');

          audio.src = ExpireErrorMP3;
          audio.play();

          setTimeout(() => {
            setIsViewAlert(false);
          }, 5000)
          return;
        }
        else if (responseData.status === 401) {
          setFirstAlertText('로그인 정보가 만료되었습니다');
          setSecondAlertText('재 로그인 후 사용해주세요');

          setIsViewAlert(true);
          setIsViewCompleteAttendance(false);
          setIsProcessing(false);

          setMiddlePhone('');
          setLastPhone('');

          audio.src = ExpireErrorMP3;
          audio.play();

          setTimeout(() => {
            setIsViewAlert(false);
            window.close();
          }, 5000)
          return;
        }
        else {
          setFirstAlertText('회원권 조회에 실패했습니다');
          setSecondAlertText('잠시후 다시시도해주세요');

          setIsViewAlert(true);
          setIsViewCompleteAttendance(false);
          setIsProcessing(false);

          setMiddlePhone('');
          setLastPhone('');

          audio.src = ExpireErrorMP3;
          audio.play();

          setTimeout(() => {
            setIsViewAlert(false);
          }, 5000)
          return;
        }
      }
    )();
  }

  // 예약 내역 확인 텍스트 //
  function calcMyReserve(data) {
    if (data.classDate === undefined) return '없음';
    else {
      return moment(data.classDate).format('YY년 MM월 DD일') + ' ' + data.classTime.split('-')[0] + ' (' + data.lessonName + ')';
    }
  }

  // D-day 계산
  function calcMyRemainDate(data) {
    // 오늘이 끝나는 날이면 //
    if (moment(data.endDate).format('YYYY.MM.DD') === moment('YYYY.MM.DD')) return 'D-Day';
    else {
      return 'D-' + parseInt(moment.duration(moment(data.endDate).diff(moment())).asDays());
    }
  }

  // 남은 횟수 계산 //
  function calcMyRemainReserveCount(data) {
    // 오늘이 끝나는 날이면 //
    if (data.totalMax === -1) return '제한 없음';
    else {
      if (data.count === undefined) return '0/' + data.totalMax + '사용 횟수';
      else return data.count + '/' + data.totalMax + ' 사용 횟수';
    }
  }

  // 출석을 진행할 회원권 클릭시 //
  function onClickTicket(data) {
    const audio = new Audio();

    // 사용횟수가 초과된 경우 //
    if (data.count >= data.totalMax && data.totalMax !== -1) {

      // 최대 사용량을 초과하였습니다.
      setFirstAlertText('최대 사용량을 초과하였습니다');
      setSecondAlertText('다른 회원권을 사용해주세요');

      audio.src = ExpireErrorMP3;
      audio.play();

      setIsViewAlert(true);

      setTimeout(() => {
        resetAll();
      }, 5000)
    }
    else {
      setProcessingText('예약 내역을 확인중입니다');
      setIsProcessing(true);

      if (data.isHolding) {
        setIsViewHoldingModal(true);
        setHoldingUsage(data);
        setIsProcessing(false);
      }
      else {
        let requestData = {
          usageId: data.usageId
        }

        const fetchModule = new FetchModule();
        (
          async () => {
            const responseData = await fetchModule.postDataVersion2('reserve/attendance/check', 'POST', requestData);

            if (responseData.status === 200) {
              // setFirstAlertText('출석이 완료되었습니다');
              // setSecondAlertText('3초뒤 메인화면으로 이동합니다');

              audio.src = EntranceMP3;
              audio.play();

              // setIsViewAlert(true);
              // setIsProcessing(false);

              setAttendanceData(responseData.data);
              setDayOfWeek(moment().format('ddd'));
              setIsViewCompleteAttendance(true);
              setIsProcessing(false);

              setTimeout(() => {
                resetAll();
              }, 5000)
            }
            else if (responseData.status === 202) {
              // 금일 사용가능한 회원권이 아닙니다 //
              setFirstAlertText('사용가능한 회원권이 아닙니다');
              setSecondAlertText('5초뒤 메인화면으로 이동합니다');

              audio.src = ExpireErrorMP3;
              audio.play();

              setIsViewAlert(true);
              setIsProcessing(false);

              setTimeout(() => {
                resetAll();
              }, 5000)
            }
            else {
              setIsProcessing(false);

              setClickTicket(data);
              setIsSelectBox(true);
            }
          }
        )();
      }
    }
  }

  // 시간표가 아닌 방문을 클릭시 //
  function onClickEmptyClass() {
    let requestData = {
      usageId: clickTicket.usageId,
      reserveId: clickTicket.reserveId === undefined ? 0 : clickTicket.reserveId
    }

    setProcessingText('출석 처리를 진행중입니다');
    setIsProcessing(true);

    const audio = new Audio();

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('reserve/attendance', 'POST', requestData);

        if (responseData.status === 200) {
          // setFirstAlertText('출석이 완료되었습니다');
          // setSecondAlertText('3초뒤 메인화면으로 이동합니다');

          audio.src = EntranceMP3;
          audio.play();

          setAttendanceData(responseData.data);
          setDayOfWeek(moment().format('ddd'));
          setIsViewCompleteAttendance(true);
          setIsProcessing(false);

          setTimeout(() => {
            resetAll();
          }, 5000);
        }
        else if (responseData.status === 201) {
          // 금일 사용량을 초과하였습니다.
          setFirstAlertText('금일 사용량을 초과하였습니다');
          setSecondAlertText('5초뒤 메인화면으로 이동합니다');
          setIsProcessing(false);
          setIsViewAlert(true);

          audio.src = ExpireErrorMP3;
          audio.play();

          setTimeout(() => {
            resetAll();
          }, 5000);
        }
        else if (responseData.status === 202) {
          // 금주 사용량을 초과하였습니다.
          setFirstAlertText('금주 사용량을 초과하였습니다');
          setSecondAlertText('5초뒤 메인화면으로 이동합니다');
          setIsProcessing(false);
          setIsViewAlert(true);

          audio.src = ExpireErrorMP3;
          audio.play();

          setTimeout(() => {
            resetAll();
          }, 5000);
        }
        else if (responseData.status === 203) {
          // 최대 사용량을 초과하였습니다.
          setFirstAlertText('최대 사용량을 초과하였습니다');
          setSecondAlertText('5초뒤 메인화면으로 이동합니다');
          setIsProcessing(false);
          setIsViewAlert(true);

          audio.src = ExpireErrorMP3;
          audio.play();

          setTimeout(() => {
            resetAll();
          }, 5000);
        }
        // else if (responseData.status === 204 || responseData.status === 205) {
        //   // 예약내역이 없는경우.
        //   setFirstAlertText('올바르지 않은 예약 데이터입니다');
        //   setSecondAlertText('3초뒤 메인화면으로 이동합니다');
        // }
        // else if (responseData.status === 205) {
        //   // 올바르지 않은 예약 데이터의 경우 //
        //   setFirstAlertText('최대 사용량을 초과하였습니다');
        //   setSecondAlertText('3초뒤 메인화면으로 이동합니다');
        // }
        else {
          // 기타 에러
          setFirstAlertText('출석에 실패하였습니다');
          setSecondAlertText('5초뒤 메인화면으로 이동합니다');
          setIsViewAlert(true);

          audio.src = ExpireErrorMP3;
          audio.play();

          setTimeout(() => {
            resetAll();
          }, 5000);
        }

        // setIsViewAlert(true);
        // setIsProcessing(false);
      }
    )();
  }

  // 출석을 진행할 수업을 선택시 //
  function onClickClass(data) {

    const audio = new Audio();

    // 예약 가능 수업이 아닌 경우 //
    if (!clickTicket.lessonIds.includes(data.lessonId)) {
      setFirstAlertText('예약이 불가능한 수업입니다');
      setSecondAlertText('다른 수업을 선택해주세요');

      setIsViewAlert(true);
      setIsProcessing(false);

      audio.src = ExpireErrorMP3;
      audio.play();

      setTimeout(() => {
        setIsViewAlert(false);
      }, 5000)

      return;
    }

    let requestData = {
      id: clickTicket.reserveId === undefined ? 0 : clickTicket.reserveId,
      scheduleId: data.scheduleId,
      lessonId: data.lessonId,
      classTime: data.classTime,
      classDate: data.classDate.replaceAll('.', '-') + 'T00:00:00',
      userId: '',
      status: 1,
      usageId: clickTicket.usageId
    }

    setProcessingText('출석 처리를 진행중입니다');
    setIsProcessing(true);

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('reserve/attendance/class', 'POST', requestData);

        if (responseData.status === 200) {
          // setFirstAlertText('출석이 완료되었습니다');
          // setSecondAlertText('3초뒤 메인화면으로 이동합니다');

          audio.src = EntranceMP3;
          audio.play();

          setAttendanceData(responseData.data);
          setDayOfWeek(moment().format('ddd'));
          setIsViewCompleteAttendance(true);
          setIsProcessing(false);

          setTimeout(() => {
            resetAll();
          }, 5000)
        }
        else if (responseData.status === 201) {
          // 금일 사용량을 초과하였습니다.
          setFirstAlertText('금일 사용량을 초과하였습니다');
          setSecondAlertText('5초뒤 메인화면으로 이동합니다');

          audio.src = ExpireErrorMP3;
          audio.play();

          setIsViewAlert(true);
          setIsProcessing(false);

          setTimeout(() => {
            // 데이터 초기화 //
            resetAll();
          }, 5000)
        }
        else if (responseData.status === 202) {
          // 금주 사용량을 초과하였습니다.
          setFirstAlertText('금주 사용량을 초과하였습니다');
          setSecondAlertText('5초뒤 메인화면으로 이동합니다');

          audio.src = ExpireErrorMP3;
          audio.play();

          setIsViewAlert(true);
          setIsProcessing(false);

          setTimeout(() => {
            // 데이터 초기화 //
            resetAll();
          }, 5000)
        }
        else if (responseData.status === 203) {
          // 최대 사용량을 초과하였습니다.
          setFirstAlertText('최대 사용량을 초과하였습니다');
          setSecondAlertText('5초뒤 메인화면으로 이동합니다');

          audio.src = ExpireErrorMP3;
          audio.play();

          setIsViewAlert(true);
          setIsProcessing(false);

          setTimeout(() => {
            // 데이터 초기화 //
            resetAll();
          }, 5000)
        }
        else if (responseData.status === 204 || responseData.status === 205) {
          // 예약내역이 없는경우.
          setFirstAlertText('올바르지 않은 예약 데이터입니다');
          setSecondAlertText('5초뒤 메인화면으로 이동합니다');

          audio.src = ExpireErrorMP3;
          audio.play();

          setIsViewAlert(true);
          setIsProcessing(false);

          setTimeout(() => {
            // 데이터 초기화 //
            resetAll();
          }, 5000)
        }
        else if (responseData.status === 206) {
          // 금주 사용량을 초과하였습니다.
          setFirstAlertText('수강 인원이 초과하였습니다');
          setSecondAlertText('5초뒤 메인화면으로 이동합니다');

          audio.src = ExpireErrorMP3;
          audio.play();

          setIsViewAlert(true);
          setIsProcessing(false);

          setTimeout(() => {
            // 데이터 초기화 //
            resetAll();
          }, 5000)
        }
        else if (responseData.status === 207) {
          // 금주 사용량을 초과하였습니다.
          setFirstAlertText('이미 수강한 수업입니다');
          setSecondAlertText('5초뒤 메인화면으로 이동합니다');

          audio.src = ExpireErrorMP3;
          audio.play();

          setIsViewAlert(true);
          setIsProcessing(false);

          setTimeout(() => {
            // 데이터 초기화 //
            resetAll();
          }, 5000)
        }
      }
    )();
  }

  // 뒤로가기 버튼 클릭 처리 //
  function onClickBack() {
    if (isSelectClass || isInfoView || isDuplicateView) {
      setIsSelectBox(false);
      setIsInfoView(false);
      setIsDuplicateView(false);
      setLastPhone('');
      setMiddlePhone('');
      setIsInputPhone(false);

      if (KeypadRef.current) {
        KeypadRef.current.style.zIndex = 1;
        KeypadRef.current.style.opacity = 1;
      }

      if (InfoRef.current) {
        InfoRef.current.style.zIndex = 0;
        InfoRef.current.style.opacity = 0;
      }
    }
    else {
      history.goBack();
    }
  }

  // 전체화면 토글 버튼 클릭 처리 //
  function onClickFullscreen(e) {
    e.stopPropagation();

    if (isFullscreen) {
      const docu = document;
      if (docu.webkitExitFullscreen) docu.webkitExitFullscreen();
      else if (docu.exitFullscreen) docu.exitFullscreen();
      else if (docu.mozCancelFullScreen) docu.mozCancelFullScreen();
      else if (docu.msExitFullscreen) docu.msExitFullscreen();
      else setIsFullscreen(false);
    }
    else {
      const docuElem = document.documentElement;
      const request = docuElem.requestFullscreen || docuElem.webkitRequestFullscreen ||
        docuElem.mozRequestFullScreen || docuElem.msRequestFullScreen;
      if (request) {
        request.call(docuElem).catch(() => {
          setIsFullscreen(true);
        });
      }
      else {
        setIsFullscreen(true);
      }
    }
  }

  // 패드 외부 클릭 시 전체화면 버튼 표시 //
  function onClickOutsidePad() {
    if (isShowFullscreenButton) return;
    setIsShowFullscreenButton(true);
    setTimeout(() => {
      setIsShowFullscreenButton(false);
    }, 5000);
  }

  // 중복정보 창에서 회원 정보 클릭시 //
  function onClickMyInfo(data) {
    const audio = new Audio();

    setProcessingText('회원권을 확인중 입니다');
    setIsProcessing(true);

    let requestData = {
      memberId: data.memberId,
      phone: data.phone
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('reserve/history/check', 'POST', requestData);

        if (responseData.status === 200) {
          setMemberInfo(responseData.data);

          let usages = responseData.data.usages.slice();

          for (let i = 0; i < usages.length; i++) {
            let ids = usages[i].availableLessonIds.split(',');

            let newIds = [];

            for (let j = 0; j < ids.length; j++) {
              newIds.push(parseInt(ids[j]));
            }

            usages[i].lessonIds = newIds;
          }

          setUsages(usages);

          setIsProcessing(false);
          setIsDuplicateView(false);

          // 유효회원권이 2개 이상인 경우 //
          if (usages.length > 1) {
            setIsInfoView(true);

            if (InfoRef.current) {
              InfoRef.current.style.zIndex = 1;
              InfoRef.current.style.opacity = 1;
            }

            if (KeypadRef.current) {
              KeypadRef.current.style.zIndex = 0;
              KeypadRef.current.style.opacity = 0;
            }
          }
          // 유효회원권이 1개인 경우 //
          else {
            onClickTicket(usages[0]);
          }
        }
        // 유효회원권이 존재하지 않는 회원의 경우 //
        else if (responseData.status === 201) {
          // alert('사용가능한 회원권이 존재하지 않습니다.\n회원권을 구매해주세요');
          setFirstAlertText('사용가능한 회원권이 없습니다');
          setSecondAlertText('회원권 구매 후 이용해주세요');

          setIsViewAlert(true);
          setIsProcessing(false);

          setMiddlePhone('');
          setLastPhone('');

          audio.src = ExpireErrorMP3;
          audio.play();

          setTimeout(() => {
            resetAll();
          }, 5000)
          return;
        }
        else if (responseData.status === 202) {
          setFirstAlertText('금일 사용량을 초과하였습니다');
          setSecondAlertText('5초뒤 메인화면으로 이동합니다');

          setIsViewAlert(true);
          setIsProcessing(false);

          setMiddlePhone('');
          setLastPhone('');

          audio.src = ExpireErrorMP3;
          audio.play();

          setTimeout(() => {
            resetAll();
          }, 5000)
          return;
        }
        else {
          setFirstAlertText('회원권 조회에 실패했습니다');
          setSecondAlertText('잠시후 다시시도해주세요');

          setIsViewAlert(true);
          setIsProcessing(false);

          setMiddlePhone('');
          setLastPhone('');

          audio.src = ExpireErrorMP3;
          audio.play();

          setTimeout(() => {
            resetAll();
          }, 5000)
          return;
        }
      }
    )();
  }

  // 수업 선택 화면 닫기 //
  function onClickExitSelectClass() {
    setLastPhone('');
    setIsSelectBox(false);
  }

  // 홀딩 해제 '예' 클릭시 //
  function onClickHoldingModalYes() {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postData('membership/release/holding/' + holdingUsage.usageId, 'POST');

        if (responseData.status === 200) {
          let newData = holdingUsage;

          newData.isHolding = false;

          onClickTicket(newData);
          setHoldingUsage(undefined);
          setIsViewHoldingModal(false);
        }
      }
    )();
  }

  // 키패드 전체 상태 초기화 //
  function resetAll() {
    setLastPhone('');
    setMiddlePhone('');
    setIsInputPhone(false);
    setIsViewAlert(false);
    setIsViewCompleteAttendance(false);
    setIsSelectBox(false);
    setIsDuplicateView(false);
    setIsInfoView(false);
    setIsProcessing(false);
    setMemberInfo({ profile: '' });
    setUsages([]);
    setClickTicket({});
    setDuplicateMembers([]);
    setHoldingUsage(undefined);
    setIsViewHoldingModal(false);
    if (InfoRef.current) {
      InfoRef.current.style.zIndex = 0;
      InfoRef.current.style.opacity = 0;
    }
    if (KeypadRef.current) {
      KeypadRef.current.style.zIndex = 1;
      KeypadRef.current.style.opacity = 1;
    }
  }

  // 홀딩 해제 '아니요' 클릭시 //
  function onClickHoldingModalNo() {
    resetAll();
  }


  return (
    <TopLevelWrapper isFullscreen={isFullscreen} onClick={onClickOutsidePad}>
      {
        isProcessing &&
        <WaittingModal text={processingText} />
      }
      {/* {isViewAlert && <AlertModal firstText={firstAlertText} secondText={secondAlertText} />} */}
      {
        isViewHoldingModal &&
        <HoldingStateModal
          onClickYes={onClickHoldingModalYes}
          onClickNo={onClickHoldingModalNo} />
      }
      <FullscreenButton onClick={onClickFullscreen} isVisible={isShowFullscreenButton}>
        <img src={isFullscreen ? FullScreenOn : FullScreenOff} alt='fullscreen' />
      </FullscreenButton>
      <PadViewWrapper
        isCompleteAttendance={(isViewCompleteAttendance || isViewAlert)}
        isFullscreen={isFullscreen}
        onClick={e => e.stopPropagation()}>
        <RingRingImagesWrapper onClick={onClickOutsidePad}>
          <TotalRingRingWrapper>
            <RingRingWrapper>
              <RingRing src={OpenEyesRingRing} isView={(!isInputPhone && !isViewCompleteAttendance && !isViewAlert)} />
              <CloseEyesRingRingImg src={CloseEyesRingRing} isView={(isInputPhone && !isViewCompleteAttendance && !isViewAlert)} />
            </RingRingWrapper>
            <NotFoundRingRingWrapper>
              <NotFoundRingRing src={NotFoundedRingRing} isView={isViewAlert} />
            </NotFoundRingRingWrapper>
          </TotalRingRingWrapper>
          {isViewCompleteAttendance &&
            <TotalRingRingHandImageWrapper isFriday={dayOfTheWeek === 'Fri'}>
              <RingRingHandImageWrapper>
                <RingRingHandImage src={dayOfTheWeek === 'Fri' ? RingRingHand : RingRingHands} />
              </RingRingHandImageWrapper>
            </TotalRingRingHandImageWrapper>
          }
          {isViewCompleteAttendance && dayOfTheWeek === 'Fri' &&
            <FridayWeekRingRingWrapper>
              <WeekRingRing src={FridayRingRing} isView={true} />
            </FridayWeekRingRingWrapper>
          }
          {isViewCompleteAttendance && dayOfTheWeek !== 'Fri' &&
            <WeekRingRingWrapper>
              <WeekRingRing src={MondayRingRing} isView={dayOfTheWeek === 'Mon'} />
              <WeekRingRing src={TuesdayRingRing} isView={dayOfTheWeek === 'Tue'} />
              <WeekRingRing src={WedsdayRingRing} isView={dayOfTheWeek === 'Wed'} />
              <WeekRingRing src={ThursdayRingRing} isView={dayOfTheWeek === 'Thu'} />
              <WeekRingRing src={MondayRingRing} isView={dayOfTheWeek === 'Sat'} />
              <WeekRingRing src={MondayRingRing} isView={dayOfTheWeek === 'Sun'} />
            </WeekRingRingWrapper>
          }
        </RingRingImagesWrapper>
        <PadView>
          {!isSelectClass && !isViewAlert && !isViewCompleteAttendance && (isDuplicateView || isInfoView) &&
            <BackButton onClick={onClickBack}>
              <img src={LeftArrow} alt='back' />
            </BackButton>
          }
          {isSelectClass && !isViewAlert && !isViewCompleteAttendance &&
            <ClassSelectView
              useScheduleData={useScheduleData}
              reserveData={reserveData}
              setReserveData={setReserveData}
              setIsSelectBox={onClickExitSelectClass}
              onClickEmptyClass={onClickEmptyClass}
              onClickClass={onClickClass} />
          }
          {isDuplicateView && !isViewAlert && !isViewCompleteAttendance &&
            <DuplicateMemberSelectView
              duplicateMembers={duplicateMembers}
              lastPhone={lastPhone}
              onClickMyInfo={onClickMyInfo}
              close={() => setIsDuplicateView(false)} />
          }
          {isInfoView && !isSelectClass && !isViewAlert && !isViewCompleteAttendance &&
            <TicketSelectView
              memberInfo={memberInfo}
              usages={usages}
              onClickTicket={onClickTicket}
              calcMyReserve={calcMyReserve}
              calcMyRemainDate={calcMyRemainDate}
              calcMyRemainReserveCount={calcMyRemainReserveCount}
            />
          }
          {isViewAlert &&
            <NotFoundView firstText={firstAlertText} secondText={secondAlertText} />
          }
          {isViewCompleteAttendance &&
            <WeekAttendanceStatusView
              dayOfTheWeek={dayOfTheWeek}
              attendanceData={attendanceData} />
          }
          {!isSelectClass && !isDuplicateView && !isInfoView && !isViewCompleteAttendance && !isViewAlert &&
            <KeypadInputView
              KeypadRef={KeypadRef}
              lastPhone={lastPhone}
              setLastPhone={setLastPhone}
              LastRef={LastRef}
              onClickNumber={onClickNumber}
              onClickRemove={onClickRemove}
              onClickFindInfo={onClickFindInfo}
            />
          }
          <PoweredByLinkoImage />
        </PadView>
      </PadViewWrapper>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: ${props => props.isFullscreen ? 'flex-end' : 'flex-start'};
  align-items: center;

  box-sizing: border-box;
  overflow: hidden;
  width: 100%;
  min-height: 100%;
  height: 100svh;

  padding-top: env(safe-area-inset-top);
  padding-bottom: ${props => props.isFullscreen ? 'max(4dvh, env(safe-area-inset-bottom))' : 'env(safe-area-inset-bottom)'};
  padding-left: env(safe-area-inset-left);
  padding-right: env(safe-area-inset-right);

  background-color: #0A0A0A;

  @media (min-height: 700px) {
    justify-content: ${props => props.isFullscreen ? 'center' : 'flex-start'};
    padding-bottom: env(safe-area-inset-bottom);
  }
`;

const PadViewWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: ${props => props.isCompleteAttendance ? `center` : `flex-end`};

  ${props => props.isFullscreen && `
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 48vh;
    min-width: 300px;
    max-width: 800px;

    @media (max-height: 699px) {
      top: calc(50% - 52px);
    }
  `}

  margin-top: ${props => props.isFullscreen ? '0' : 'auto'};
  margin-bottom: ${props => props.isFullscreen ? '0' : 'auto'};
`;

const RingRingImagesWrapper = styled.div`
  display: contents;
`;

const TotalRingRingWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;
`;

const FullscreenButton = styled.div`
  position: fixed;
  top: 3vh;
  right: 20px;
  z-index: 9999;

  display: flex;
  justify-content: center;
  align-items: center;

  width: 48px;
  height: 48px;

  background: #777777;
  border-radius: 16px;

  cursor: pointer;

  opacity: ${props => props.isVisible ? 1 : 0};
  visibility: ${props => props.isVisible ? `visible` : `hidden`};

  // @media (max-width: 480px) {
  //   opacity: 1;
  //   visibility: visible;
  // }

  img {
    width: 26px;
    height: 26px;
  }

  &:hover {
    background: #888888;
  }

  transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out, background 0.2s ease-in-out;
`;

const RingRingWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-right: 100px;
  width: 200px;
  height: 191px;
  z-index: 899;

  @media (min-height: 320px) {
    margin-right: 20px;
    width: 110px;
    height: 105px;
  }
  @media (min-height: 640px) {
    margin-right: 30px;
    width: 120px;
    height: 115px;
  }
  @media (min-height: 680px) {
    margin-right: 40px;
    width: 140px;
    height: 134px;
  }
  @media (min-height: 720px) {
    margin-right: 60px;
    width: 150px;
    height: 143px;
  }
  @media (min-height: 800px) {
    margin-right: 70px;
    width: 160px;
    height: 153px;
  }
  @media (min-height: 1000px) {
    margin-right: 80px;
    width: 180px;
    height: 172px;
  }
  @media (min-height: 1200px) {
    margin-right: 100px;
    width: 200px;
    height: 191px;
  }

  @media (max-height: 680px) {
    margin-right: 18px;
    width: 80px;
    height: 76px;
  }
`;

const NotFoundRingRingWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  top: calc(107px + 2vh);
  left: 50%;
  transform: translateX(-50%);

  width: 199px;
  height: 127px;

  z-index: 1000;

  @media (min-height: 320px) {
    top: calc(21px + 2vh);

    width: 199px;
    height: 127px;
  }
  @media (min-height: 640px) {
    top: calc(16px + 2vh);

    width: 236px;
    height: 150px;
  }
  @media (min-height: 680px) {
    top: calc(12px + 2vh);

    width: 290px;
    height: 184px;
  }
  @media (min-height: 720px) {
    top: calc(4.9px + 2vh);

    width: 330px;
    height: 208px;
  }
  @media (min-height: 800px) {
    top: calc(-1px + 2vh);

    width: 371px;
    height: 232px;
  }
  @media (min-height: 1000px) {
    top: calc(-4px + 2vh);

    width: 417px;
    height: 265px;
  }
  @media (min-height: 1200px) {
    top: calc(0px + 2vh);

    width: 453px;
    height: 288px;
  }

  @media (max-height: 680px) {
    top: calc(10px + 1vh);

    width: 160px;
    height: 102px;
  }
`;

const NotFoundRingRing = styled.img`
  width: 100%;
  height: 100%;

  opacity: ${props => props.isView ? `1` : `0`};
`;

const RingRing = styled.img`
  position: absolute;

  // margin-top: 7px;

  width: 200px;
  height: 191px;

  z-index: 1001;

  opacity: ${props => props.isView ? `1` : `0`};

  @media (min-height: 320px) {
    margin-top: calc(3.9px + 2vh);

    width: 110px;
    height: 105px;
  }
  @media (min-height: 640px) {
    margin-top: calc(4.5px + 2vh);

    width: 120px;
    height: 115px;
  }
  @media (min-height: 680px) {
    margin-top: calc(4.9px + 2vh);

    width: 140px;
    height: 134px;
  }
  @media (min-height: 720px) {
    margin-top: calc(5.5px + 2vh);

    width: 150px;
    height: 143px;
  }
  @media (min-height: 800px) {
    margin-top: calc(5.9px + 2vh);

    width: 160px;
    height: 153px;
  }
  @media (min-height: 1000px) {
    margin-top: calc(6.98px + 2vh);

    width: 180px;
    height: 172px;
  }
  @media (min-height: 1200px) {
    margin-top: calc(6.9px + 2vh);

    width: 200px;
    height: 191px;
  }

  @media (max-height: 680px) {
    margin-top: calc(3px + 1vh);

    width: 80px;
    height: 76px;
  }
`;

const CloseEyesRingRingImg = styled(RingRing)`
  @media (min-height: 320px) {
    margin-top: calc(6px + 2vh);

    width: 110px;
    height: 99.5px;
  }
  @media (min-height: 640px) {
    margin-top: calc(5.5px + 2vh);

    width: 120px;
    height: 109.5px;
  }
  @media (min-height: 680px) {
    margin-top: calc(5.5px + 2vh);

    width: 140px;
    height: 128.5px;
  }
  @media (min-height: 720px) {
    margin-top: calc(5.5px + 2vh);

    width: 150px;
    height: 137.5px;
  }
  @media (min-height: 800px) {
    margin-top: calc(5.5px + 2vh);

    width: 160px;
    height: 147.5px;
  }
  @media (min-height: 1000px) {
    margin-top: calc(5px + 2vh);

    width: 180px;
    height: 166.5px;
  }
  @media (min-height: 1200px) {
    margin-top: calc(5px + 2vh);

    width: 200px;
    height: 185.5px;
  }

  @media (max-height: 680px) {
    margin-top: calc(4px + 1vh);

    width: 80px;
    height: 73px;
  }
`;

const WeekRingRingWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  left: 50%;
  z-index: 0;
  top: calc(85px + 2vh);
  transform: translateX(-50%);
  width: 130px;
  height: 115px;

  @media (min-height: 320px) {
    top: calc(0px + 2vh);
    width: 130px;
    height: 115px;
  }
  @media (min-height: 640px) {
    top: calc(-10px + 2vh);
    width: 160px;
    height: 141px;
  }
  @media (min-height: 680px) {
    top: calc(-5px + 2vh);
    width: 180px;
    height: 154px;
  }
  @media (min-height: 720px) {
    top: calc(-15px + 2vh);
    width: 210px;
    height: 178px;
  }
  @media (min-height: 800px) {
    top: calc(-20px + 2vh);
    width: 230px;
    height: 194px;
  }
  @media (min-height: 1000px) {
    top: calc(-15px + 2vh);
    width: 250px;
    height: 209px;
  }
  @media (min-height: 1200px) {
    top: calc(-15px + 2vh);
    width: 270px;
    height: 225px;
  }

  @media (max-height: 680px) {
    top: -5px;
    width: 95px;
    height: 84px;
    z-index: 2;
  }
`;

const FridayWeekRingRingWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  left: 50%;
  z-index: 10;
  top: calc(105px + 2vh);
  transform: translate(-50%, calc(-100% + 20px));
  width: 208px;
  height: 138px;

  @media (min-height: 320px) {
    top: calc(105px + 2vh);
    transform: translate(-50%, calc(-100% + 20px));
    width: 208px;
    height: 138px;
  }
  @media (min-height: 640px) {
    top: calc(115px + 2vh);
    transform: translate(-50%, calc(-100% + 23px));
    width: 246px;
    height: 162px;
  }
  @media (min-height: 680px) {
    top: calc(134px + 2vh);
    transform: translate(-50%, calc(-100% + 27px));
    width: 302px;
    height: 199px;
  }
  @media (min-height: 720px) {
    top: calc(143px + 2vh);
    transform: translate(-50%, calc(-100% + 34px));
    width: 359px;
    height: 237px;
  }
  @media (min-height: 800px) {
    top: calc(153px + 2vh);
    transform: translate(-50%, calc(-100% + 37px));
    width: 397px;
    height: 262px;
  }
  @media (min-height: 1000px) {
    top: calc(172px + 2vh);
    transform: translate(-50%, calc(-100% + 40px));
    width: 435px;
    height: 288px;
  }
  @media (min-height: 1200px) {
    top: calc(191px + 2vh);
    transform: translate(-50%, calc(-100% + 43px));
    width: 473px;
    height: 313px;
  }

  @media (max-height: 680px) {
    top: calc(60px + 1vh);
    transform: translate(-50%, calc(-100% + 15px));
    width: 165px;
    height: 108px;
  }
`;

const WeekRingRing = styled.img`
  position: absolute;

  width: 100%;
  height: 100%;

  opacity: ${props => props.isView ? `1` : `0`};

  transition: ${props => props.isView ? `all 0.1s ease-in-out` : `all 0.3s ease-in-out`};

  &:hover {
    cursor: pointer;
  }
`;

const TotalRingRingHandImageWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  margin-top: ${props => props.isFriday ? `125px` : `125px`};
  width: 100%;
  height: 100%;

  z-index: 1004;

  @media (min-height: 320px) {
    margin-top: ${props => props.isFriday ? `45px` : `45px`};
  }
  @media (min-height: 640px) {
    margin-top: ${props => props.isFriday ? `50px` : `50px`};
  }
  @media (min-height: 720px) {
    margin-top: ${props => props.isFriday ? `70px` : `70px`};
  }
  @media (min-height: 760px) {
    margin-top: ${props => props.isFriday ? `70px` : `70px`};
  }
  @media (min-height: 800px) {
    margin-top: ${props => props.isFriday ? `70px` : `70px`};
  }
  @media (min-height: 1000px) {
    margin-top: ${props => props.isFriday ? `70px` : `70px`};
  }
  @media (min-height: 1200px) {
    margin-top: ${props => props.isFriday ? `60px` : `60px`};
  }

  @media (max-height: 680px) {
    margin-top: ${props => props.isFriday ? `30px` : `30px`};
  }
`;

const RingRingHandImageWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 100%;
  // height: 100%;
`;

const RingRingHandImage = styled.img`
  width: 100%;

  @media (max-height: 680px) {
    max-width: 150px;
  }
`;


const BackButton = styled.div`
  position: absolute;
  z-index: 10;

  display: flex;
  justify-content: center;
  align-items: center;

  cursor: pointer;

  @media (min-height: 320px) {
    top: 10px;
    left: 10px;
    width: 28px;
    height: 28px;
    img { width: 8px; height: 14px; }
  }
  @media (min-height: 640px) {
    top: 12px;
    left: 12px;
    width: 32px;
    height: 32px;
    img { width: 10px; height: 17px; }
  }
  @media (min-height: 720px) {
    top: 14px;
    left: 14px;
    width: 36px;
    height: 36px;
    img { width: 12px; height: 20px; }
  }
  @media (min-height: 800px) {
    top: 16px;
    left: 16px;
    width: 40px;
    height: 40px;
    img { width: 13px; height: 22px; }
  }
  @media (min-height: 1000px) {
    top: 20px;
    left: 20px;
    width: 50px;
    height: 50px;
    img { width: 16px; height: 27px; }
  }
  @media (min-height: 1200px) {
    top: 24px;
    left: 24px;
    width: 60px;
    height: 60px;
    img { width: 20px; height: 33px; }
  }
`;

const PadView = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  z-index: 1;
  overflow: hidden;

  width: 48vh;
  min-width: 300px;
  max-width: 800px;
  // height: 90vh;
  height: 78vh;
  // height: 85vh;
  // height: 100%;
  margin-top: 2vh;
  min-height: 568px;
  // min-height: 500px;
  max-height: 1480px;

  // box-shadow: 0px 40px 50px rgba(240, 232, 227, 0.5);
  box-shadow: 0px 40px 50px rgba(10, 10, 10, 0.5);
  border-radius: 30px;
  background-color: #FFFFFF;

  @media (max-height: 680px) {
    height: 68vh;
    min-height: 454px;
    margin-top: 0.5vh;
  }
`;
